import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Text from 'components/text/text';
import classNames from 'classnames';
import Icon from 'components/icons/icon';
import Button from 'components/button/button';
import GridRow from 'components/grid/grid-row';
import GridCol from 'components/grid/grid-col';
import DefaultProductInfo from 'pages/product-matches/_default-product-info';
import SaddleProductInfo from 'pages/product-matches/_saddle-product-info';

export default function ProductMatch(props) {
  const data = props.data;

  const image = function() {
    return (
      <img
        src={data.image}
        alt="3D Render"
        className="img img_md mix-img_centered"
      />
    );
  };

  const renderInfo = function() {
    if (data.type === 'saddle') {
      return (
        <SaddleProductInfo data={data} />
      );
    }
    else {
      return (
        <DefaultProductInfo data={data} />
      );
    }
  };

  const info = function() {
    return (
      <div className="set mix-set_centered mix-set_slim">
        {renderInfo()}
      </div>
    );
  }

  const bodyClasses = classNames(
    'set-bd',
    {
      'set-bd_super': props.index === 0,
      'set-bd_isolated': props.index > 0,
    }
  )

  return (
    <div className={bodyClasses}>
      <GridRow>
        <GridCol desktop="6" mobile="4" tablet="8" tabletLg="4" className="cell_detachedSm cell_detachedMd mix-cell_noGutterMobile">
          {image()}
        </GridCol>

        <GridCol desktop="6" mobile="4" tablet="8" tabletLg="4" className="cell_detachedSm cell_detachedMd mix-cell_noGutterMobile">
          <Icon
            className="icon_right mix-icon_compactTop"
            iconSize="lg"
            iconType="specialized"
          />

          {info()}
        </GridCol>
      </GridRow>
    </div>
  );
}

const dataShape = PropTypes.shape({
  'image': PropTypes.string,
  'type': PropTypes.string
});

ProductMatch.propTypes = {
  'data': PropTypes.object.isRequired,
  'index': PropTypes.number
};



// WEBPACK FOOTER //
// ./src/client/pages/product-matches/_product-match.jsx